var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            dark: "",
                            dense: "",
                            color: "green",
                            flat: ""
                          }
                        },
                        [_c("span", [_vm._v("Project Code Form")])]
                      ),
                      _c("create-project-code")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            dark: "",
                            dense: "",
                            flat: "",
                            color: "green"
                          }
                        },
                        [_c("span", [_vm._v("Project Codes")])]
                      ),
                      _c("table-project-code")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }